import { render, staticRenderFns } from "./LogoutAsUserPage.vue?vue&type=template&id=523e9bcc&"
import script from "./LogoutAsUserPage.vue?vue&type=script&lang=js&"
export * from "./LogoutAsUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523e9bcc')) {
      api.createRecord('523e9bcc', component.options)
    } else {
      api.reload('523e9bcc', component.options)
    }
    module.hot.accept("./LogoutAsUserPage.vue?vue&type=template&id=523e9bcc&", function () {
      api.rerender('523e9bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LogoutAsUserPage.vue"
export default component.exports